import { useEffect, useState } from 'react';
import { EnrichedMatchRequest, mockBackend } from '../services/mockBackend';
import StatusBadge from './StatusBadge';
import { userFacingError } from '../utils/errors';

type AdminMatchesPanelProps = {
  refreshToken: number;
};

const AdminMatchesPanel = ({ refreshToken }: AdminMatchesPanelProps) => {
  const [items, setItems] = useState<EnrichedMatchRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    mockBackend.matches
      .listAdminMatches()
      .then((matches) => {
        if (active) setItems(matches);
      })
      .catch((loadError) => {
        if (active) setError(userFacingError(loadError, 'Não foi possível carregar os matches.'));
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [refreshToken]);

  if (loading) {
    return (
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body text-white-50">Carregando matches...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body">
          <div className="alert alert-danger py-2 mb-0">{error}</div>
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="card bg-onyx border-0 shadow-lg">
        <div className="card-body text-white-50">Nenhum match registrado.</div>
      </div>
    );
  }

  return (
    <div className="card bg-onyx border-0 shadow-lg">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 className="text-white mb-1">Auditoria de match</h5>
            <p className="text-white-50 mb-0">Acompanhe pedidos, negociações e eventos consolidados.</p>
          </div>
          <span className="badge bg-brand text-white">{items.length}</span>
        </div>

        <div className="row g-3">
          {items.map((item) => (
            <div className="col-xl-6" key={item.id}>
              <div className="card bg-dark border-0 h-100">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
                    <div>
                      <strong className="d-block text-white">
                        {item.sourceEvent.title} ↔ {item.targetEvent.title}
                      </strong>
                      <span className="text-white-50 small">
                        {item.initiator.name} → {item.targetUser.name}
                      </span>
                    </div>
                    <StatusBadge kind="match" status={item.status} />
                  </div>

                  <div className="small text-white-50 mb-3">
                    Aguardando: {item.awaitingUser?.name || 'Administração'}
                  </div>

                  <div className="selected-match-box mb-3">
                    <strong className="text-white d-block mb-1">Proposta</strong>
                    <div className="text-white">{item.proposal.title}</div>
                    <div className="text-white-50 small">
                      {new Date(item.proposal.startAt).toLocaleString('pt-BR')} · {item.proposal.location}
                    </div>
                  </div>

                  {item.convertedEvent && (
                    <div className="metric-card">
                      <span>Evento consolidado</span>
                      <strong>{item.convertedEvent.title}</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminMatchesPanel;
